import { render, staticRenderFns } from "./platformManagement.vue?vue&type=template&id=3448481a&scoped=true"
import script from "./platformManagement.vue?vue&type=script&lang=js"
export * from "./platformManagement.vue?vue&type=script&lang=js"
import style0 from "./platformManagement.vue?vue&type=style&index=0&id=3448481a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448481a",
  null
  
)

export default component.exports